import {error} from 'console';
import {title} from 'process';
import {ReactNode} from 'react';
import css from './SetupContainer.module.scss';

export type SetupBageState = 'Warning' | 'Success' | 'Failed';

export type SetupContaninerProps = {
  title: ReactNode;
  warning: boolean;
  header: ReactNode;
  steps: ReactNode[];
  action?: ReactNode;
};

export const SetupContainer = (props: SetupContaninerProps) => {
  return (
    <div className={css.setup_container}>
      <div className={props.warning ? css.warning : css.success}>
        {props.title}
      </div>
      <div>
        <div className={css.body}>
          <div className={css.info}>{props.header}</div>
          <div className={css.steps}>
            {insertBetween(props.steps, <hr className={css.divider} />)}
          </div>
          <div>{props.action}</div>
        </div>
      </div>
    </div>
  );
};

export type SetupContainerStepProps = {
  title: string;
  badge: string;
  state: SetupBageState;
  error?: ReactNode;
};

export const SetupContainerStep = (props: SetupContainerStepProps) => {
  let badgeClass = 'unknown';
  if (props.state == 'Warning') {
    badgeClass = css.badge_warning;
  }
  if (props.state == 'Success') {
    badgeClass = css.badge_success;
  }
  if (props.state == 'Failed') {
    badgeClass = css.badge_failed;
  }

  return (
    <div className={css.step_container}>
      <div className={css.step}>
        <div>{props.title}</div>
        <div className={badgeClass}>{props.badge}</div>
      </div>
      <div>{props.error}</div>
    </div>
  );
};

function insertBetween<T>(arr: T[], elem: T): T[] {
  if (arr.length < 2) return arr.slice();

  const result: T[] = [];
  for (let i = 0; i < arr.length; i++) {
    result.push(arr[i]);
    if (i < arr.length - 1) {
      result.push(elem);
    }
  }
  return result;
}
